import React from 'react';

export default function CircleSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 475 475">
      <filter id="a">
        <feGaussianBlur in="SourceAlpha" stdDeviation="15" />
        <feComponentTransfer>
          <feFuncA slope=".2" type="linear" />
        </feComponentTransfer>
        <feMerge>
          <feMergeNode />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <path
        fill="#0d74ff"
        d="M236.05 31.45c-114.59 0-207.49 92.9-207.49 207.5s92.9 207.49 207.49 207.49 207.5-92.9 207.5-207.49-92.9-207.5-207.5-207.5zm0 310.67A103.18 103.18 0 1 1 339.23 239a103.17 103.17 0 0 1-103.18 103.12z"
        filter="url(#a)"
      />
    </svg>
  );
}
